import styled from 'styled-components'

export const HeaderMain = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  max-height: calc(100vh - 280px);
  min-height: 480px;
  position: relative;
  isolation: isolate;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: auto;
  border-radius: 27px 27px 20px 20px;
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.25);

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #002b80;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #a6c10b;
  }
`

export const HeaderTitle = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: linear-gradient(to right, #001842, #00205b, #002b80);
  border-radius: 27px 27px 0 0;
  min-width: max-content;
  width: 100%;
  height: 60px;
  color: #ffffff;
  z-index: 10;
  padding: 0 20px;
  font-family: 'Montserrat', sans-serif;
  flex-shrink: 0;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);

  .header-text {
    font-size: 12px;
    font-weight: 800;
    width: 120px;
    min-width: 120px;
    margin-right: 16px;
    color: #ffffff;
  }

  .li {
    display: flex;
    flex: 1;
    width: 100%;
    height: 100%;
    gap: 8px;
    padding: 0;
    justify-content: space-between;
    color: #ffffff;

    span {
      color: #ffffff;
    }
  }

  @media (max-width: 768px) {
    height: 50px;

    .header-text {
      font-size: 14px;
      width: 120px;
      min-width: 120px;
    }
  }
`

export const HeaderContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background: #dadada;
  min-width: max-content;
  width: 100%;
  padding: 0 20px 23px 20px;
  flex: 1;
  border-radius: 0 0 20px 20px;
`
